import Vue from 'vue'
import App from './App.vue'
import RichText from './components/MarkdownWithKatex.vue'
Vue.component('RichText', RichText)
import router from './router'
// 导入 Element UI 和全部的样式
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/mobile-overlays.scss'
import "./plugins/EUtils"
import Katex from 'vue-katex-auto-render'
Vue.directive('katex', Katex);
import "katex/dist/contrib/mhchem"
const isProduction = process.env.NODE_ENV === 'production';
Vue.prototype.dataurl = isProduction ? 'https://m.shangkao.com.cn' : '/lpl';
Vue.prototype.osUrl = isProduction ? 'https://skos.shangkao.com.cn/' : '/lplos/';
import store from './store'
// 使用 Element UI
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
